import { useState } from "react";
import type { FailArticle } from "@/mocks/articles";

export default function ScreenshotGallery({ items }: { items: FailArticle["screenshots"] }) {
  const [active, setActive] = useState<number | null>(null);

  return (
    <section aria-labelledby="shots-title" className="w-full">
      <h2 id="shots-title" className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-2 flex items-center gap-2">
        <span className="w-8 h-8 rounded-md bg-accent-100 text-accent-900 flex items-center justify-center">
          <i className="ri-image-2-line"></i>
        </span>
        关键截图
      </h2>
      <p className="text-sm text-foreground-600 mb-6">
        点击图片可放大查看。站内图片为契合内容的示意画面，不包含当事人真实影像。
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {items.map((shot, index) => (
          <figure key={shot.url} className="rounded-lg overflow-hidden bg-background-100 border border-background-200">
            <button
              type="button"
              onClick={() => setActive(index)}
              className="block w-full aspect-square overflow-hidden cursor-zoom-in"
              aria-label={`放大查看：${shot.caption}`}
            >
              <img src={shot.url} alt={shot.alt} className="w-full h-full object-cover object-top" />
            </button>
            <figcaption className="px-4 py-3 text-xs md:text-sm text-foreground-600 leading-relaxed">
              <i className="ri-camera-lens-line mr-1.5 text-foreground-400"></i>
              {shot.caption}
            </figcaption>
          </figure>
        ))}
      </div>

      {active !== null && (
        <div
          className="fixed inset-0 z-[60] bg-foreground-950/90 flex items-center justify-center p-4"
          role="dialog"
          aria-modal="true"
          onClick={() => setActive(null)}
        >
          <div className="relative max-w-2xl w-full" onClick={(event) => event.stopPropagation()}>
            <img
              src={items[active].url}
              alt={items[active].alt}
              className="w-full rounded-lg object-contain max-h-[75vh]"
            />
            <p className="mt-3 text-sm text-background-200 text-center">{items[active].caption}</p>
            <button
              type="button"
              onClick={() => setActive(null)}
              aria-label="关闭"
              className="absolute -top-3 -right-3 w-9 h-9 rounded-full bg-background-50 text-foreground-950 flex items-center justify-center cursor-pointer hover:bg-accent-400 transition-colors"
            >
              <i className="ri-close-line text-lg"></i>
            </button>
          </div>
        </div>
      )}
    </section>
  );
}